import React, { memo } from 'react';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import BtnPopoverSmall from './BtnPopoverSmall';

const getIcon = () => {
  return (<MusicNoteIcon fontSize={'small'} />);
};

const BtnSong = (props) => {
  return (
    <BtnPopoverSmall title={props.title} getIcon={getIcon}>
      {props.children}
    </BtnPopoverSmall>
  );
};

export default memo(BtnSong);
